import styled from 'styled-components';

export const Main = styled.main`
  background: #fff;
  position: relative;
  overflow-x: hidden;
  margin: 0 auto;
  width: 100%;
`;
